import type { FormInstance } from 'antd';

type ValidationFailure = {
  errorFields: { name: (string | number)[] }[];
};

const focusFirstFormError =
  (form: FormInstance<any>) =>
  ({ errorFields }: ValidationFailure) => {
    const [firstError] = errorFields;

    if (firstError) {
      form.scrollToField(firstError.name, { focus: true });
    }
  };

export default focusFirstFormError;
